import { render, staticRenderFns } from "./SelectedItems.vue?vue&type=template&id=5140e96f&scoped=true&"
import script from "./SelectedItems.vue?vue&type=script&lang=ts&"
export * from "./SelectedItems.vue?vue&type=script&lang=ts&"
import style0 from "./SelectedItems.vue?vue&type=style&index=0&id=5140e96f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5140e96f",
  null
  
)

export default component.exports